import { useAppData, type ThemePref } from "../state/AppData";

const OPTIONS: { key: ThemePref; label: string }[] = [
  { key: "system", label: "Auto" },
  { key: "light", label: "Light" },
  { key: "dark", label: "Dark" },
];

export function ThemeToggle() {
  const { themePref, setThemePref } = useAppData();
  return (
    <div className="theme-toggle" role="group" aria-label="Theme">
      {OPTIONS.map((o) => (
        <button key={o.key} data-active={themePref === o.key} onClick={() => setThemePref(o.key)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
